import React, { useState } from 'react';
import Hero from '../components/Hero';

const Idiomas = () => {
  const [idiomaSelecionado, setIdiomaSelecionado] = useState('pt');

  const idiomas = [
    {
      codigo: 'pt',
      nome: 'Português',
      bandeira: '🇧🇷',
      descricao: 'Idioma oficial do Brasil e nossa língua principal'
    },
    {
      codigo: 'en',
      nome: 'English',
      bandeira: '🇺🇸',
      descricao: 'English language for international visitors'
    },
    {
      codigo: 'es',
      nome: 'Español',
      bandeira: '🇪🇸',
      descricao: 'Idioma español para visitantes hispanohablantes'
    }
  ];

  const conteudoPorIdioma = {
    pt: {
      titulo: 'Selecione seu Idioma',
      subtitulo: 'Escolha o idioma de sua preferência',
      descricao: 'Navegue pelo site no idioma que você se sente mais confortável.',
      hero: {
        title: 'Conexão Saúde',
        subtitle: 'Conectando pessoas à saúde de qualidade',
        description: 'Uma organização sem fins lucrativos dedicada a promover acesso à saúde de qualidade para comunidades carentes.'
      },
      estatisticas: {
        titulo: 'Nossos Números',
        subtitulo: 'O impacto positivo que geramos',
        dados: [
          { numero: '10K+', descricao: 'Pessoas Atendidas' },
          { numero: '50+', descricao: 'Projetos Realizados' },
          { numero: '200+', descricao: 'Voluntários Ativos' },
          { numero: '15', descricao: 'Cidades Atendidas' }
        ]
      },
      servicos: {
        titulo: 'Nossos Serviços',
        subtitulo: 'Cuidados de saúde acessíveis e de qualidade',
        lista: [
          'Consultas Médicas Gratuitas',
          'Atendimento Psicológico',
          'Educação em Saúde',
          'Saúde da Mulher',
          'Saúde Infantil',
          'Saúde do Idoso'
        ]
      }
    },
    en: {
      titulo: 'Select Your Language',
      subtitulo: 'Choose your preferred language',
      descricao: 'Browse the website in the language you feel most comfortable with.',
      hero: {
        title: 'Health Connection',
        subtitle: 'Connecting people to quality healthcare',
        description: 'A non-profit organization dedicated to promoting access to quality healthcare for underserved communities.'
      },
      estatisticas: {
        titulo: 'Our Numbers',
        subtitulo: 'The positive impact we generate',
        dados: [
          { numero: '10K+', descricao: 'People Served' },
          { numero: '50+', descricao: 'Projects Completed' },
          { numero: '200+', descricao: 'Active Volunteers' },
          { numero: '15', descricao: 'Cities Served' }
        ]
      },
      servicos: {
        titulo: 'Our Services',
        subtitulo: 'Accessible and quality healthcare',
        lista: [
          'Free Medical Consultations',
          'Psychological Care',
          'Health Education',
          'Women\'s Health',
          'Child Health',
          'Elderly Health'
        ]
      }
    },
    es: {
      titulo: 'Selecciona tu Idioma',
      subtitulo: 'Elige tu idioma preferido',
      descricao: 'Navega por el sitio web en el idioma con el que te sientas más cómodo.',
      hero: {
        title: 'Conexión Salud',
        subtitle: 'Conectando personas con atención médica de calidad',
        description: 'Una organización sin fines de lucro dedicada a promover el acceso a atención médica de calidad para comunidades desfavorecidas.'
      },
      estatisticas: {
        titulo: 'Nuestros Números',
        subtitulo: 'El impacto positivo que generamos',
        dados: [
          { numero: '10K+', descricao: 'Personas Atendidas' },
          { numero: '50+', descricao: 'Proyectos Realizados' },
          { numero: '200+', descricao: 'Voluntarios Activos' },
          { numero: '15', descricao: 'Ciudades Atendidas' }
        ]
      },
      servicos: {
        titulo: 'Nuestros Servicios',
        subtitulo: 'Atención médica accesible y de calidad',
        lista: [
          'Consultas Médicas Gratuitas',
          'Atención Psicológica',
          'Educación en Salud',
          'Salud de la Mujer',
          'Salud Infantil',
          'Salud del Adulto Mayor'
        ]
      }
    }
  };

  const conteudo = conteudoPorIdioma[idiomaSelecionado];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <Hero
        title={conteudo.hero.title}
        subtitle={conteudo.hero.subtitle}
        description={conteudo.hero.description}
        showButtons={false}
      />

      {/* Seleção de Idioma */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {conteudo.titulo}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {conteudo.descricao}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {idiomas.map((idioma) => (
              <button
                key={idioma.codigo}
                onClick={() => setIdiomaSelecionado(idioma.codigo)}
                className={`p-6 rounded-lg border-2 transition-all duration-200 ${
                  idiomaSelecionado === idioma.codigo
                    ? 'border-primary-600 bg-primary-50 shadow-lg'
                    : 'border-gray-200 hover:border-primary-300 hover:shadow-md'
                }`}
              >
                <div className="text-center">
                  <div className="text-6xl mb-4">{idioma.bandeira}</div>
                  <h3 className={`text-xl font-semibold mb-2 ${
                    idiomaSelecionado === idioma.codigo ? 'text-primary-600' : 'text-gray-900'
                  }`}>
                    {idioma.nome}
                  </h3>
                  <p className="text-gray-600 text-sm">{idioma.descricao}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Conteúdo Dinâmico */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {conteudo.estatisticas.titulo}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {conteudo.estatisticas.subtitulo}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
            {conteudo.estatisticas.dados.map((dado, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-2">
                  {dado.numero}
                </div>
                <div className="text-gray-600 font-medium">
                  {dado.descricao}
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {conteudo.servicos.titulo}
            </h2>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              {conteudo.servicos.subtitulo}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
              {conteudo.servicos.lista.map((servico, index) => (
                <div key={index} className="bg-white rounded-lg shadow-md p-6 text-center">
                  <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">{servico}</h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Informações sobre Idiomas */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Acessibilidade Linguística
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Acreditamos que o acesso à saúde deve ser universal, incluindo a comunicação.
                Por isso, oferecemos suporte em múltiplos idiomas para garantir que todas as
                pessoas possam acessar nossos serviços e informações.
              </p>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Tradução Profissional</h3>
                    <p className="text-gray-600">Conteúdo traduzido por profissionais especializados</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Atendimento Multilíngue</h3>
                    <p className="text-gray-600">Equipe capacitada para atendimento em diferentes idiomas</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-primary-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Material Educativo</h3>
                    <p className="text-gray-600">Cartilhas e materiais disponíveis em múltiplos idiomas</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Idiomas Disponíveis</h3>
              <div className="space-y-4">
                {idiomas.map((idioma) => (
                  <div key={idioma.codigo} className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50">
                    <span className="text-2xl">{idioma.bandeira}</span>
                    <div>
                      <h4 className="font-semibold text-gray-900">{idioma.nome}</h4>
                      <p className="text-sm text-gray-600">{idioma.descricao}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-6 p-4 bg-primary-50 rounded-lg">
                <p className="text-sm text-primary-800">
                  <strong>Precisa de outro idioma?</strong> Entre em contato conosco para solicitar suporte em idiomas adicionais.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Precisa de Ajuda em Outro Idioma?
          </h2>
          <p className="text-xl text-primary-100 mb-8 max-w-3xl mx-auto">
            Entre em contato conosco e nossa equipe multilíngue estará pronta para atendê-lo.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contato"
              className="bg-white text-primary-600 hover:bg-gray-100 font-semibold py-3 px-8 rounded-lg transition-colors duration-200 shadow-lg"
            >
              Entre em Contato
            </a>
            <a
              href="tel:+5511999999999"
              className="border-2 border-white text-white hover:bg-white hover:text-primary-600 font-semibold py-3 px-8 rounded-lg transition-colors duration-200"
            >
              Ligar Agora
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Idiomas;
